// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__p-hjF","productName":"Table_productName__2gLJS"};